import { CircularProgress, makeStyles } from '@material-ui/core';
import React from 'react';

const useStyle = makeStyles({
  root: {
    display: 'flex',
    position: 'fixed',
    left: 0,
    top: 0,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    zIndex: 1410,
    width: '100%',
    background: 'rgba(0,0,0,0.5)',
  },
});

function PageLoader() {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <CircularProgress size={30} style={{ color: 'rgba(0, 0, 0, 0.87)' }} />
    </div>
  );
}
export default PageLoader;
